import type { ModelEventsParams, onAfterSaveType, onBeforeSaveType } from 'app/main/components/hooks/useModel';

const DetailsEventsWrapper =
	<T extends onBeforeSaveType | onAfterSaveType>(params: ModelEventsParams) =>
	(events: T[]) => {
		const promises = events.map(event => event(params));
		return Promise.all(promises).then(results => {
			return Object.assign(params.modifiedModel, ...results);
		});
	};

export default DetailsEventsWrapper;
